import { Box, BoxProps, Link, useMediaQuery } from "@chakra-ui/react";
import { Logo, LogoBird } from "@ui/../icons";

export const LinkedLogo = (
  props: BoxProps & { primary?: string; secondary?: string },
) => {
  const [isLargeBp] = useMediaQuery("(min-width: 992px)");
  let url;
  switch (process.env.DOPPLER_STAGE) {
    case "dev":
      url = "http://localhost:3001/";
      break;
    case "prd":
      url = "http://areahub.com/";
      break;
    case "stg":
      url = "https://staging.areahub.info";
      break;
    default:
      url = "http://areahub.com/";
  }

  return (
    <Link href={url} aria-label="Go to the homepage">
      <Box as={isLargeBp ? Logo : LogoBird} {...props} />
    </Link>
  );
};
